import { Prospect, ProspectJson } from '@gi/models/prospect';
import { HttpHelper } from '@helpers/http.helper';
import { Company, CompanyJson } from '@models/company';
import { User, UserJson } from '@models/user';

export interface CreateCompanyJson {
  company: Partial<CompanyJson>;
  user: Partial<UserJson>;
  is_capital_deposit: boolean;
  prospect: Partial<ProspectJson>;
}

export class CreateCompany {
  constructor(
    public company: Company,
    public user: User,
    public isCapitalDeposit?: boolean,
    public prospect?: Prospect
  ) {}

  static toJson(model: CreateCompany): CreateCompanyJson {
    return {
      company: {
        name: HttpHelper.toJsonProperty(model.company.name),
        legal_form: HttpHelper.toJsonProperty(model.company.legalForm),
        siret: HttpHelper.toJsonProperty(model.company.siret),
        reference: HttpHelper.toJsonProperty(model.company.reference),
        legal_structure: model.company.legalStructure?.id ? HttpHelper.toJsonId(model.company.legalStructure) : null,
        signatory: model.company.signatory?.id ? HttpHelper.toJsonId(model.company.signatory) : null,
        ape_code: model.company.apeCode?.id ? HttpHelper.toJsonId(model.company.apeCode) : null,
        street: HttpHelper.toJsonProperty(model.company.street),
        postal_code: HttpHelper.toJsonProperty(model.company.postalCode),
        city: HttpHelper.toJsonProperty(model.company.city),
        tiime_business_optin: HttpHelper.toJsonProperty(model.company.tiimeBusinessOptin)
      },
      user: {
        id: HttpHelper.toJsonProperty(model.user.id),
        email: HttpHelper.toJsonProperty(model.user.email),
        phone: HttpHelper.toJsonProperty(model.user.phone),
        civility: HttpHelper.toJsonProperty(model.user.civility),
        firstname: HttpHelper.toJsonProperty(model.user.firstName),
        lastname: HttpHelper.toJsonProperty(model.user.lastName),
        capacity: HttpHelper.toJsonProperty(model.user.capacity),
        mailing_street: HttpHelper.toJsonProperty(model.user.mailingStreet),
        mailing_postal_code: HttpHelper.toJsonProperty(model.user.mailingPostalCode),
        mailing_city: HttpHelper.toJsonProperty(model.user.mailingCity)
      },
      is_capital_deposit: HttpHelper.toJsonProperty(model.isCapitalDeposit),
      prospect: model.prospect?.id ? HttpHelper.toJsonId(model.prospect) : null
    };
  }
}
